export default __webpack_public_path__ + "static/media/communication-devices.75fcfbde.PNG";